import { defineStore } from "pinia";
import { allMenuItems } from "@/constants/menuItems";

const normalizeMenuUrl = (href: string): string =>
  href.startsWith("/") ? href : `/${href}`;

export const useAppSidebarMenuStore = defineStore("appSidebarMenu", {
  state: () => ({
    menuItems: [] as {
      text?: string;
      is_header?: boolean;
      title?: string;
      url?: string;
      icon?: string;
    }[],
  }),

  actions: {
    setMenuItems() {
      this.menuItems = [
        { text: "Navigation", is_header: false },
        ...allMenuItems.map((item) => ({
          title: item.nombre,
          url: normalizeMenuUrl(item.href),
          icon: item.icon,
        })),
      ];
    },
  },

  persist: true,
});
